<template>
    <div class="container-fluid">
        <div class="row" v-if="product">
            <div class="col-12">
                <div class="header mt-md-5">
                    <div class="header-body">
                        <div class="row align-items-center">
                            <div class="col-auto" v-if="product.avatar">
                                <avatar :src="product.avatar.preview" />
                            </div>
                            <div class="col">
                                <b-breadcrumb :items="items"></b-breadcrumb>
                                <!--<h6 class="header-pretitle">{{$t('Supplies')}}</h6>-->
                                <h1 class="header-title">{{ product.label }}</h1>
                            </div>
                            <!-- <div class="col-auto">
                                <navigation></navigation>
                            </div>-->
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center">
            <div class="col">
                <router-view :productId="productId"></router-view>
            </div>
        </div>
    </div>
</template>


<script>
import Avatar from '@/components/Avatar';
import Navigation from './Navigation';
import { mapActions, mapGetters, mapState } from 'vuex';
export default {
    props: ['productId'],
    data() {
        return {
            items: [
                {
                    text: this.$t('Materials'),
                    href: '#/materials'
                },
                {
                    text: this.$t('Supplies'),
                    active: true
                }
            ]
        }
    },
    components: {
        Avatar,
        Navigation
    },
    computed: {
        ...mapGetters('products', {
            getProduct: 'get'
        }),
        product() {

            return this.getProduct(this.productId);
        }
    },
    created() {
        this.get(this.productId);
    },
    methods: {
        ...mapActions('products', ['get']),

    }
}
</script>
